<template>
	<div>
		<div class="" style="position: fixed;top: 130px;left: 30px;z-index: 999;">
			<div style="display: flex; justify-content: end; margin-right: 25px">
				<div class="title-img-tab">
					<div id="title-img-tab1" @click="changSwitch(0)">产品溯源</div>
					<div id="title-img-tab2" @click="changSwitch(1)">产品信息</div>
				</div>
			</div>
		</div>
		<div v-if="switchCurrent == '1'" class="" style="margin-top: 30px;">
			<el-row :gutter="20">
				<el-col :span="18">
					<div class="" style="width: 100%;height: 821px;margin-top: 20px;">
						<div class="" style="width: 100%;height: 100%;">
							<div class=""
								style="display: flex;align-items: center;background-color: #1f3b72;border: 1px solid #2E8DB4;border-bottom: 0px;height: 60px;">
								<div class=""
									style="width: 303px;border-right: 1px solid #2E8DB4;height: 100%;font-size: 16px;color: #A8CCDE;">
									<div class="right">
										时间
									</div>
									<div class="left">
										种类
									</div>
								</div>
								<div class=""
									style="text-align: center;width:calc(100% - 303px);font-size: 16px;color: #A8CCDE;font-weight: 500;">
									价格信息
								</div>
							</div>
							<div class="tableML" style="width: 100%;height: 100%;">
								<el-table height="100%" v-if="listDate.length!=0" :data="listDate" border
									:stripe="false" :highlight-current-row="false">
									<el-table-column type="index" label="序号" width="101" align="center">
										<template slot="header">
											<div class="" style="color: #18FEF0;font-weight: 400;">
												序号
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="farmProduceName" label="名称" width="100" align="center">
										<template slot="header">
											<div class="" style="color: #18FEF0;font-weight: 400;">
												名称
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="farmProducePic" label="图片" width="100" align="center">
										<template slot="header">
											<div class="" style="color: #18FEF0;font-weight: 400;">
												图片
											</div>
										</template>
										<template slot-scope="scope">
											<div class=""
												style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
												<img :src="scope.row.farmProducePic"
													style="width: 80px;height: 80px;border-radius: 5px;" />
											</div>
										</template>
									</el-table-column>
									<el-table-column label="当日价格" width="auto" min-width="100" align="center">
										<template slot="header">
											<div class="" style="color: #18FEF0;font-weight: 400;">
												当日价格
											</div>
										</template>
										<template slot-scope="scope">
											{{scope.row.priceTrendList[0].priceTrendBprice}}
										</template>
									</el-table-column>
									<el-table-column align="center" width="auto"
										v-for="(items,indexs) in priceTrendList" :key="indexs">
										<template slot="header">
											<div class="" style="font-weight: 400;">
												{{new Date(items.priceTrendTime).getMonth() + 1}}.{{new Date(items.priceTrendTime).getDate()}}
											</div>
										</template>
										<template slot-scope="scope">
											{{scope.row.priceTrendList[indexs+1].priceTrendBprice}}
										</template>
									</el-table-column>
									<el-table-column prop="address" align="center" width="auto" min-width="100">
										<template slot="header">
											<div class="" style="font-weight: 400;color: #18FEF0;">
												较昨日价格
											</div>
										</template>
										<template slot-scope="scope">
											<div v-if="priceTrendListImtTackle(scope.row) == 1" class=""
												style="display: flex;align-items:center;width: 100%;justify-content: center;color: #2FFF00;">
												<img src="@/assets/img/rise.png" />
												<div class="" style="margin-left: 5px;font-size: 16px;">
													{{parseFloat(scope.row.priceTrendList[0].priceTrendBprice - scope.row.priceTrendList[1].priceTrendBprice).toFixed(2) }}
												</div>
											</div>
											<div v-if="priceTrendListImtTackle(scope.row) == 2" class=""
												style="display: flex;align-items:center;width: 100%;justify-content: center;color: #FA4848;">
												<img src="@/assets/img/drop.png" alt="" sizes="" srcset="" />
												<div class="" style="margin-left: 5px;font-size: 16px;">
													{{parseFloat(scope.row.priceTrendList[1].priceTrendBprice -scope.row.priceTrendList[0].priceTrendBprice).toFixed(2)  }}
												</div>
											</div>
											<div v-if="priceTrendListImtTackle(scope.row) == 0" class=""
												style="display: flex;align-items:center;width: 100%;justify-content: center;">
												<div class="" style="margin-left: 5px;font-size: 16px;">
													0
												</div>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
					</div>
				</el-col>
				<el-col :span="6">
					<div class="tableML">
						<div class="">
							<div class="title-img">
								<div class="title">趋势分析</div>
							</div>
							<div class="state-bg">
								<div class=""
									style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
									<div id="main1" style="padding: 0px; width: 95%; height: 257px"></div>
								</div>

							</div>
						</div>

						<div class="">
							<div class="title-img">
								<div class="title">产品种类</div>
							</div>
							<div class="state-bg" style="height: 483px;margin-bottom: 0px;position: relative;">
								<div class="" style="width: 90%;height: 100%;">
									<div class="roll" style="">
										<div class="" style="width: 100%;">
											<el-checkbox style="margin-bottom: 15px;" @change="chartInit" v-model="item.show"
												size="medium" v-for="(item,index) in listDate"
												:key="index">{{item.farmProduceName}}</el-checkbox>
										</div>
										
											
									</div>
								</div>
								
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>

		<el-row v-if="switchCurrent == '0'" :gutter="20">
			<el-col :span="14">
				<div class="">
					<div class="wrapper">
						<div class="map-container" style="width: 100%; height: 100%;" ref="myEchart"></div>
					</div>
					<div class="trace-data-bg">
						<div style="
                font-size: 22px;
                font-weight: bold;
                color: #77e9ff;
                text-align: center;
                margin: 10px 0;
              ">
							作物列表
						</div>
						<div class="trace-data-body">
							<div class="trace-list-body">
								<div>
									<el-row>
										<el-col :span="10">
											<div class="">产品名称</div>
										</el-col>
										<el-col :span="6">
											<div class="">所属园区</div>
										</el-col>
										<el-col :span="3">
											<div class=""></div>
											所属批次
										</el-col>
										<!-- <el-col :span="3"><div class="">阶段</div></el-col> -->
										<el-col :span="2">
											<div class="" style="text-align: center">溯源码</div>
										</el-col>
										<el-col :span="3">
											<div class="" style="text-align: center">详情</div>
										</el-col>
									</el-row>
								</div>
								<div class="trace-list-body-item">
									<div v-for="(item, index) in traceabilityList" :key="index">
										<el-row :class="
                        index % 2 == 0
                          ? current == index
                            ? 'trace-list-body-item-bgs'
                            : 'trace-list-body-item-bg'
                          : current == index
                          ? 'trace-list-body-item-bgs'
                          : ''
                      ">
											<el-col :span="10">
												<div class="">{{ item.traceabilityName }}</div>
											</el-col>
											<el-col :span="6">
												<div class="">{{ item.massifName }}</div>
											</el-col>

											<el-col :span="3">
												<div class="">{{ item.traceabilityBatch }}</div>
											</el-col>
											<el-col :span="2">
												<div class="" @click="imgBigListClick(item.traceabilityId)" style="
                            text-align: center;
                            text-decoration: underline;
                            cursor: pointer;
                          ">
													查看
												</div>
											</el-col>
											<el-col :span="3">
												<div class="" @click="
                            traceabilityDetail(item.traceabilityId);
                            current = index;
                          " style="text-align: center">
													点击进入...
												</div>
											</el-col>
										</el-row>
									</div>
									<div v-if="traceabilityList.length == 0" style="margin-top: -20px">
										<el-empty :image-size="75" description="暂无数据"
											image="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705376475598.png"></el-empty>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="10">
				<div class="">
					<div class="title-img">
						<div style="margin-right: 100px; margin-top: -10px; float: right">
							统计
						</div>
					</div>
					<div class="">
						<div class="data-sum-count-body">
							<div class="data-sum-count-body-item-bg">
								<div class="data-sum-count-body-item">
									<div>
										<div class="data-sum-count-body-item-num">
											{{ traceabilityList.length }}
										</div>
										<div>全部作物统计（个）</div>
									</div>
									<div>
										<img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702345497320.png"
											alt="" />
									</div>
								</div>
							</div>
							<div class="data-sum-count-body-item-bg">
								<div class="data-sum-count-body-item">
									<div>
										<div class="data-sum-count-body-item-num">
											{{ traceabilityList.length }}
										</div>
										<div>溯源码生成数量（个）</div>
									</div>
									<div>
										<img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702345497320.png"
											alt="" />
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="data-info-list">
						<div class="data-info-list-title">溯源信息</div>
						<div v-if="traceabilityDetailLists.length != 0" class="data-info-list-body">
							<div class="data-info-list-item" v-for="(item, index) in traceabilityDetailLists"
								:key="index">
								<div style="font-size: 19px">
									{{ item.traceabilityStepName }}
								</div>
								<div style="
                    display: flex;
                    justify-content: start;
                    margin-top: 10px;
                  ">
									<div style="line-height: 23px">
										{{ item.traceabilityStepTime }}
									</div>
									<div style="margin-left: 10%; display: flex; align-items: center">
										<img style="width: 26px; height: 26px; margin-right: 10px"
											src="https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704246862448.png"
											alt="" />{{ item.traceabilityStepWorker }}
									</div>
								</div>
								<div style="display: flex; flex-wrap: wrap">
									<div class="data-info-list-item-imgs"
										v-for="(items, indexs) in item.traceabilityStepPic" :key="indexs" @click="
                      imgShow = true;
                      imgBigList = item.traceabilityStepPic;
                      imgType = 2;
                      imgCurrent = indexs;
                    ">
										<img :src="items" style="width: 60px; height: 60px; border-radius: 5px;object-fit: cover;" />
									</div>
								</div>
							</div>
						</div>
						<div v-else style="margin-top: 200px">
							<el-empty :image-size="75" description="暂无数据"
								image="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705376475598.png"></el-empty>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>

		<el-dialog :title="imgType == 2 ? '阶段查看' : '溯源码'" :visible.sync="imgShow" :width="imgType == 2 ? '35%' : '22%'"
			:center="true">
			<img v-if="imgType == 1" :src="imgBigList[imgCurrent]"
				style="width: 90%; height: 350px; margin-top: 30px; margin-left: 5%" alt="aspectFill" />
			<img v-if="imgType == 2" :src="imgBigList[imgCurrent]" style="width: 100%; height: 550px; margin-top: 30px"
				alt="aspectFill" />
			<span slot="footer" class="dialog-footer">
				<el-button type="info" @click="imgCurrent = imgCurrent - 1" v-if="imgCurrent != 0">Prev</el-button>
				<el-button type="primary" @click="imgCurrent = imgCurrent + 1"
					v-if="imgCurrent != imgBigList.length - 1">Next</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import * as echarts from "echarts";
	import "@/plugins/china.js";
	export default {
		name: "app",
		components: {},
		data() {
			return {
				imgBigList: [
					"https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702348140870.png",
					"https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702349443533.png",
					"https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702349592602.png",
				],
				imgShow: false,
				imgCurrent: 0,
				traceabilityList: [],
				traceabilityDetailLists: [],
				userInfo: null,
				current: 0,
				imgType: 0,
				// ML所写
				switchCurrent: 0,
				myEchart: '',
				tableData: [{
					name: '王小虎',
					province: '上海',
					city: '普陀区',
					address: '上海市普陀区金沙江路',
					zip: 200333,
					dwaiod: "154",
					fenopda: "89",
					year: "12178"
				}],
				listDate: [],
				priceTrendList: [],
			};
		},
		mounted() {
			if (this.switchCurrent == 0) {
				this.changSwitchInit();
			} else if (this.switchCurrent == 1) {
				this.productInformationInit();
			}
		},
		methods: {
			// ML所写内容
			changSwitch(type) {
				let div = document.querySelector("#title-img-tab1");
				let div1 = document.querySelector("#title-img-tab2");
				if (type == 0) {
					div.style.background = "#2C83EF";
					div1.style.background = "transparent";
				} else {
					this.facilityList = [];
					this.relayList = [];
					div1.style.background = "#2C83EF";
					div.style.background = "transparent";
				}
				this.switchCurrent = type;

				if (this.switchCurrent == 0) {
					this.myEchart = '';
					this.changSwitchInit();
				} else if (this.switchCurrent == 1) {
					this.productInformationInit();
				}
			},
			productInformationInit() {
				let userInfo = localStorage.getItem("user_info");
				// 将获取到的JSON字符串转换回对象
				this.userInfo = JSON.parse(userInfo);
				console.log("userInfo", this.userInfo);
				let currentDate = new Date();
				let year = currentDate.getFullYear();
				let month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); //月份是从0开始计数的，所以要加1
				let day = currentDate.getDate().toString().padStart(2, "0");

				let dateStr = `${year}-${month}-${day}`;
				console.log("dateStr", dateStr)
				let httpData = {
					deptId: this.userInfo.dept.deptId,
					limitNum: 10,
					dateStr: dateStr
				};
				this.$axios.get("/farmProduce/listDate", {
					params: httpData
				}).then((res) => {
					console.log("res", res);
					if (res.data) {
						let data = res.data;
						for (let i = 0; i < data.length; i++) {
							data[i].show = false;
						}
						data[0].show = true;
						this.priceTrendList = JSON.parse(JSON.stringify(data[0].priceTrendList));
						this.priceTrendList.shift();
						this.listDate = res.data;
						this.chartInit();
					}
				}).catch((error) => {
					console.log("error", error)
				});
			},
			chartInit() {
				let xAxisData = [];
				let seriesData = [];
				for (let i = 0; i < this.listDate[0].priceTrendList.length; i++) {
					let currentDate = new Date(this.listDate[0].priceTrendList[i].priceTrendTime);
					let year = currentDate.getFullYear();
					let month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); //月份是从0开始计数的，所以要加1
					let day = currentDate.getDate().toString().padStart(2, "0");
					let dateStr = `${year}-${month}-${day}`;
					xAxisData.push(dateStr);

				}
				let listDate = [];
				let legendData = [];
				for (let i = 0; i < this.listDate.length; i++) {
					if (this.listDate[i].show) {
						let priceTrendListData = [];
						for (let j = 0; j < this.listDate[i].priceTrendList.length; j++) {
							priceTrendListData.push(this.listDate[i].priceTrendList[j].priceTrendBprice)
						}
						legendData.push(this.listDate[i].farmProduceName);
						listDate.push({
							name: this.listDate[i].farmProduceName,
							type: 'line',
							data: JSON.parse(JSON.stringify(priceTrendListData))
						})
					}

				}
				seriesData = listDate;
				console.log("seriesData", seriesData)
				var dom = document.getElementById("main1");
				var myChart = echarts.init(dom, null, {
					renderer: "canvas",
					useDirtyRect: false,
				});
				myChart.clear();
				var option = {
					tooltip: {
						trigger: 'axis',
					},
					grid: {
						left: '6%',
						right: '4%',
						bottom: '3%',
						containLabel: true,
					},
					xAxis: {
						type: 'category',
						data: xAxisData,
						axisLine: {
							lineStyle: {
								color: '#FFFFFF'
							}
						},
					},
					yAxis: {
						type: 'value',
						axisLine: {
							lineStyle: {
								color: '#FFFFFF'
							}
						},
					},
					series: seriesData
				};

				if (option && typeof option === "object") {
					myChart.setOption(option);
				}
				window.addEventListener("resize", myChart.resize);
			},
			priceTrendListImtTackle(row) {
				if (row.priceTrendList[0].priceTrendBprice > row.priceTrendList[1].priceTrendBprice) {
					return 1;
				} else if (row.priceTrendList[0].priceTrendBprice < row.priceTrendList[1].priceTrendBprice) {
					return 2;
				} else {
					return 0;
				}
			},
			getNextDay(dateString) {
				// console.log('--getNextDay--', dateString)
				// 创建一个日期对象
				var date = new Date(dateString);

				// 获取当前日期的毫秒数
				var milliseconds = date.getTime();

				// 将毫秒数增加一天的毫秒数
				milliseconds += 24 * 60 * 60 * 1000;

				// 创建一个新的日期对象，使用增加后的毫秒数
				var nextDay = new Date(milliseconds);

				// 获取新日期的年、月、日
				var year = nextDay.getFullYear();
				var month = nextDay.getMonth() + 1; // 月份从0开始，需要加1
				var day = nextDay.getDate();

				// 格式化日期为YYYY-MM-DD的形式
				var formattedDate =
					year +
					"-" +
					month.toString().padStart(2, "0") +
					"-" +
					day.toString().padStart(2, "0");
				// console.log('日历----', formattedDate)
				return formattedDate;
			},
			changSwitchInit() {
				// 从本地缓存中获取数据
				let userInfo = localStorage.getItem("user_info");
				// 将获取到的JSON字符串转换回对象
				this.userInfo = JSON.parse(userInfo);
				console.log("userInfo", this.userInfo)
				//查询产品溯源列表
				this.gettraceability();
				let data = [{
						name: "北京",
						dataCount: [0, 1, 0, 0, 0, 0, 1],
						id: "247",
					},
					{
						name: "天津",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "248",
					},
					{
						name: "河北",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "249",
					},
					{
						name: "山西",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "250",
					},
					{
						name: "内蒙古",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "251",
					},
					{
						name: "辽宁",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "252",
					},
					{
						name: "吉林",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "253",
					},
					{
						name: "黑龙江",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "254",
					},
					{
						name: "上海",
						dataCount: [0, 1, 0, 0, 0, 0, 0],
						id: "255",
					},
					{
						name: "江苏",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "256",
					},
					{
						name: "浙江",
						dataCount: [0, 1, 0, 0, 0, 0, 0],
						id: "257",
					},
					{
						name: "安徽",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "258",
					},
					{
						name: "福建",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "259",
					},
					{
						name: "江西",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "260",
					},
					{
						name: "山东",
						dataCount: [14235, 820, 0, 35, 0, 0, 4],
						id: "261",
					},
					{
						name: "河南",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "262",
					},
					{
						name: "湖北",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "263",
					},
					{
						name: "湖南",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "264",
					},
					{
						name: "广东",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "265",
					},
					{
						name: "广西",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "266",
					},
					{
						name: "海南",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "267",
					},
					{
						name: "重庆",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "268",
					},
					{
						name: "四川",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "269",
					},
					{
						name: "贵州",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "270",
					},
					{
						name: "云南",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "271",
					},
					{
						name: "西藏",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "272",
					},
					{
						name: "陕西",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "273",
					},
					{
						name: "甘肃",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "274",
					},
					{
						name: "青海",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "275",
					},
					{
						name: "宁夏",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "276",
					},
					{
						name: "新疆",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "277",
					},
					{
						name: "台湾",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "278",
					},
					{
						name: "香港",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "279",
					},
					{
						name: "澳门",
						dataCount: [0, 0, 0, 0, 0, 0, 0],
						id: "280",
					},
				];
				let chinaGeoCoordMap = {
					黑龙江: [127.9688, 45.368, 1],
					内蒙古: [110.3467, 41.4899, 1],
					吉林: [125.8154, 44.2584, 1],
					北京: [116.4551, 40.2539, 2],
					辽宁: [123.1238, 42.1216, 1],
					河北: [114.4995, 38.1006, 1],
					天津: [117.4219, 39.4189, 1],
					山西: [112.3352, 37.9413, 1],
					陕西: [109.1162, 34.2004, 1],
					甘肃: [103.5901, 36.3043, 1],
					宁夏: [106.3586, 38.1775, 1],
					青海: [101.4038, 36.8207, 1],
					新疆: [87.9236, 43.5883, 1],
					西藏: [91.11, 29.97, 1],
					四川: [103.9526, 30.7617, 1],
					重庆: [108.384366, 30.439702, 1],
					山东: [117.1582, 36.8701, 1],
					河南: [113.4668, 34.6234, 1],
					江苏: [118.8062, 31.9208, 1],
					安徽: [117.29, 32.0581, 1],
					湖北: [114.3896, 30.6628, 1],
					浙江: [119.5313, 29.8773, 1],
					福建: [119.4543, 25.9222, 1],
					江西: [116.0046, 28.6633, 1],
					湖南: [113.0823, 28.2568, 1],
					贵州: [106.6992, 26.7682, 1],
					云南: [102.9199, 25.4663, 1],
					广东: [113.12244, 23.009505, 1],
					广西: [108.479, 23.1152, 1],
					海南: [110.3893, 19.8516, 1],
					上海: [121.4648, 31.2891, 1],
					台湾: [120.991676054688, 24.7801149726563, 1],
					澳门: [113.33, 22.11, 1],
					香港: [114.15, 22.15, 1],
				};
				for (let i = 0; i < data.length; i++) {
					var da = chinaGeoCoordMap[data[i].name];
					chinaGeoCoordMap[data[i].name] = [...da, ...data[i].dataCount];
				}
				let chinaDatas = [
					[{
						name: "北京",
						value: 2,
					}, ],
					[{
						name: "黑龙江",
						value: 1,
					}, ],
					[{
						name: "内蒙古",
						value: 1,
					}, ],
					[{
						name: "吉林",
						value: 1,
					}, ],
					[{
						name: "辽宁",
						value: 1,
					}, ],
					[{
						name: "河北",
						value: 1,
					}, ],
					[{
						name: "天津",
						value: 1,
					}, ],
					[{
						name: "山西",
						value: 1,
					}, ],
					[{
						name: "陕西",
						value: 1,
					}, ],
					[{
						name: "甘肃",
						value: 1,
					}, ],
					[{
						name: "宁夏",
						value: 1,
					}, ],
					[{
						name: "青海",
						value: 1,
					}, ],
					[{
						name: "新疆",
						value: 1,
					}, ],
					[{
						name: "西藏",
						value: 1,
					}, ],
					[{
						name: "四川",
						value: 1,
					}, ],
					[{
						name: "重庆",
						value: 1,
					}, ],
					[{
						name: "山东",
						value: 1,
					}, ],
					[{
						name: "河南",
						value: 1,
					}, ],
					[{
						name: "江苏",
						value: 1,
					}, ],
					[{
						name: "安徽",
						value: 1,
					}, ],
					[{
						name: "湖北",
						value: 1,
					}, ],
					[{
						name: "浙江",
						value: 1,
					}, ],
					[{
						name: "福建",
						value: 1,
					}, ],
					[{
						name: "江西",
						value: 1,
					}, ],
					[{
						name: "湖南",
						value: 1,
					}, ],
					[{
						name: "贵州",
						value: 1,
					}, ],
					[{
						name: "广东",
						value: 1,
					}, ],
					[{
						name: "广西",
						value: 1,
					}, ],
					[{
						name: "云南",
						value: 1,
					}, ],
					[{
						name: "海南",
						value: 1,
					}, ],
					[{
						name: "上海",
						value: 1,
					}, ],
					[{
						name: "台湾",
						value: 1,
					}, ],
					[{
						name: "澳门",
						value: 1,
					}, ],
					[{
						name: "香港",
						value: 1,
					}, ],
				];
				let convertData = function(data) {
					var res = [];
					for (var i = 0; i < data.length; i++) {
						var dataItem = data[i];
						var fromCoord = [
							chinaGeoCoordMap[dataItem[0].name][0],
							chinaGeoCoordMap[dataItem[0].name][1],
						];
						var toCoord = [103.5901, 36.3043];
						if (fromCoord && toCoord) {
							res.push([{
									coord: fromCoord,
									value: dataItem[0].value,
								},
								{
									coord: toCoord,
								},
							]);
						}
					}
					return res;
				};
				let seriesA = [];
				seriesA.push({
						type: "lines",
						zlevel: 1,
						effect: {
							show: true,
							period: 4, //箭头指向速度，值越小速度越快
							trailLength: 0.3, //特效尾迹长度[0,1]值越大，尾迹越长重
							symbol: "pin", //箭头图标
							symbolSize: 8, //图标大小
							color: "#2a6fd9",
						},
						lineStyle: {
							normal: {
								color: "#003262",
								width: 1, //尾迹线条宽度
								opacity: 0.9, //尾迹线条透明度
								curveness: 0.3, //尾迹线条曲直度
							},
						},
						data: convertData(chinaDatas),
					}, {
						type: "effectScatter",
						coordinateSystem: "geo",
						zlevel: 2,
						rippleEffect: {
							// 涟漪特效
							period: 2, // 动画时间，值越小速度越快
							brushType: "fill", // 波纹绘制方式 stroke, fill
							scale: 6, // 波纹圆环最大限制，值越大波纹越大
							color: "#003262", // 涟漪的颜色，默认为散点的颜色。
						},
						label: {
							normal: {
								show: true,
								color: "#fff",
								position: "top", // 显示位置
								offset: [0, 0], // 偏移设置
								formatter: function(params) {
									// 圆环显示文字
									return params.data.name;
								},
								fontSize: 13,
							},
							emphasis: {
								show: false,
							},
						},
						symbol: "circle",
						symbolSize: function(val) {
							return 1 + val[2] * 5; // 圆环大小
						},
						itemStyle: {
							color: "#2a6fd9",
							shadowBlur: 4,
							shadowColor: "#2a6fd9",
						},
						data: chinaDatas.map(function(dataItem) {
							return {
								name: dataItem[0].name,
								value: chinaGeoCoordMap[dataItem[0].name],
								itemStyle: {
									color: "#2a6fd9",
									shadowBlur: 4,
									shadowColor: "#2a6fd9",
								},
							};
						}),
					},
					//被攻击点
					{
						type: "scatter",
						coordinateSystem: "geo",
						zlevel: 2,
						label: {
							normal: {
								show: false,
								position: "right",
								color: "red",
								formatter: "{b}",
								textStyle: {
									color: "red",
								},
							},
							emphasis: {
								show: true,
								color: "red",
							},
						},
						symbol: "pin",
						symbolSize: 0,
						data: [{
							name: "甘肃",
							value: chinaGeoCoordMap["甘肃"].concat([10]),
						}, ],
					}
				);

				let option = {
					regions: [
						//隐藏南海
						{
							name: "南海诸岛",
							itemStyle: {
								normal: {
									borderColor: "red",
									borderWidth: 20, //设置外层边框
									opacity: 0, // 为 0 时不绘制该图形
								},
							},
							label: {
								show: false, // 隐藏文字
							},
						},
					],
					backgroundColor: "#010C2A",
					geo: {
						cache: false, // 将此处的值设置为false，即可清除地图缓存
						map: "china",
						zoom: 1.2,
						label: {
							normal: {
								color: "#fff",
							},
							emphasis: {
								show: false,
							},
						},
						roam: false, // 是否允许缩放
						itemStyle: {
							normal: {
								color: "#000", // 地图背景色
								borderColor: "#5ea8ff", // 省市边界线00fcff 516a89
								borderWidth: 1,
							},
							emphasis: {
								areaColor: "#003262",
								shadowColor: "#003262",
							},
						},
					},
					series: seriesA,
				};
				let that = this;
				setTimeout(function() {
					that.myEchart = echarts.init(that.$refs.myEchart);
					that.myEchart.setOption(option);
				}, 0);
			},
			gettraceability() {
				let params = {
					deptId: this.userInfo ? this.userInfo.dept.deptId : 0,
				};
				console.log("产品溯源列表-params===", params);
				this.$axios
					.get("/traceability/list", {
						params: params,
					})
					.then((res) => {
						console.log("产品溯源列表-res===", res);
						if (res.data.length != 0) {
							this.traceabilityList = res.data;
							this.traceabilityDetail(res.data[0].traceabilityId);
						}
					})
					.catch((error) => {
						console.log("产品溯源列表-error===", error);
					});
			},
			imgBigListClick(traceabilityId) {
				let params = {
					param: traceabilityId,
				};
				console.log("traceabilityDetail-params===", params);
				this.$axios
					.get("/traceability/getQRCode", {
						params: params,
					})
					.then((res) => {
						console.log("产品溯源阶段列表-res===", res);
						let list = [];
						list.push(res.msg);
						this.imgBigList = list;
						this.imgShow = true;
						this.imgType = 1;
					})
					.catch((error) => {
						console.log("产品溯源阶段列表-error===", error);
					});
			},
			traceabilityDetail(traceabilityId) {
				let params = {
					traceabilityStepTid: traceabilityId,
				};
				console.log("traceabilityDetail-params===", params);
				this.$axios
					.get("/traceabilityStep/list", {
						params: params,
					})
					.then((res) => {
						console.log("产品溯源阶段列表-res===", res);
						for (let i = 0; i < res.data.length; i++) {
							if (res.data[i].traceabilityStepPic != null) {
								res.data[i].traceabilityStepPic =
									res.data[i].traceabilityStepPic.split(",");
							}
						}
						this.traceabilityDetailLists = res.data;
					})
					.catch((error) => {
						console.log("产品溯源阶段列表-error===", error);
					});
			},
		},
	};
</script>

<style>
	.wrapper {
		width: 100%;
		height: 800px;
	}

	.trace-data-bg {
		position: absolute;
		top: 680px;
		width: 53%;
		height: 255px;
		background: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704266704372.png");
		background-size: 100% 100%;
	}

	.trace-data-body {
		padding: 0px 15px 15px 15px;
	}

	.trace-list-body {
		padding: 0px 30px;
	}

	.trace-list-body-item {
		margin-top: 5px;
		height: 140px;
		overflow: auto;
		scrollbar-width: thin;
		scrollbar-color: transparent transparent;
	}

	.trace-list-body-item-bg {
		background-image: linear-gradient(to left,
				transparent 0%,
				#0f4262 50%,
				transparent 100%);
	}

	.trace-list-body-item-bgs {
		background-image: linear-gradient(to left,
				transparent 0%,
				#013ba7 50%,
				transparent 100%);
	}

	.trace-list-body-item::-webkit-scrollbar {
		width: 8px;
		background-color: transparent;
	}

	.trace-list-bodyitem::-webkit-scrollbar-thumb {
		background-color: transparent;
	}

	.title-img {
		width: 100%;
		height: 50px;
		background-image: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704183078849.png");
		background-size: 100% 100%;
		font-size: 22px;
		color: #ffffff;
		font-weight: 600;
	}

	.data-sum-count-body {
		width: 92%;
		display: flex;
		justify-content: space-between;
		background: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704181399133.png");
		background-size: 100% 100%;
		padding: 2% 4%;
	}

	.data-sum-count-body-item-bg {
		width: 48%;
		background-image: url("https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702344944568.png");
		background-size: 100% 100%;
	}

	.data-sum-count-body-item {
		padding: 0.9375rem 1.875rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #fff;
	}

	.data-sum-count-body-item img {
		width: 6.5rem;
		height: 6.5rem;
	}

	.data-sum-count-body-item-num {
		color: #00fbe7;
		font-size: 1.5rem;
		font-weight: bold;
		margin-bottom: 0.625rem;
	}

	.data-info-list {
		margin-top: 1.875rem;
		width: 100%;
		height: 42.75rem;
		background-image: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704246764808.png");
		background-size: 100% 100%;
	}

	.data-info-list-title {
		text-align: center;
		padding-top: 1.25rem;
		color: #77e9ff;
		font-size: 22px;
		font-weight: bold;
	}

	.data-info-list-body {
		margin-top: 30px;
		width: 100%;
		height: 600px;
		display: flex;
		flex-wrap: wrap;
		overflow: auto;
		scrollbar-width: thin;
		scrollbar-color: transparent transparent;
	}

	.data-info-list-body::-webkit-scrollbar {
		width: 8px;
		background-color: transparent;
	}

	.data-info-list-body::-webkit-scrollbar-thumb {
		background-color: transparent;
	}

	.data-info-list-item {
		width: 90%;
		margin-left: 60px;
		margin-top: 15px;
		font-weight: bold;
	}

	.data-info-list-item-imgs {
		width: 10%;
		margin: 15px 0;
		display: flex;
		justify-content: center;
	}

	/* ML所写 */
	.title-img-tab div {
		width: 50%;
		text-align: center;
		line-height: 33px;
		font-size: 16px;
		font-weight: bold;
		border-radius: 6px;
	}

	#title-img-tab1 {
		background: #2c83ef;
	}

	.title-img-tab {
		background: rgba(44, 131, 239, 0.2);
		width: 260px;
		height: 33px;
		border-radius: 6px;
		display: flex;
		margin-top: -5px;
	}

	.left {
		text-align: left;
		position: relative;
		padding-left: 30px;
		height: 30px;
		display: flex;
		align-items: center;
		font-weight: 500;
	}

	.left::after {
		content: '';
		width: 100%;
		height: 0px;
		position: absolute;
		border-bottom: 1px solid #2E8DB4;
		top: 0;
		left: 0px;
		transform: rotate(11deg);
	}

	.right {
		text-align: right;
		padding-right: 30px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: end;
		font-weight: 500;
	}

	.tableML {

		.el-table--border,
		.el-table--group {
			border: 1px solid #2E8DB4 !important;
		}

		.el-table,
		.el-table__expanded-cell {
			background-color: #1f3b72 !important;
		}

		.el-table tr {
			background-color: #1f3b72 !important;
		}

		.el-table th.el-table__cell {
			background-color: #1f3b72 !important;
		}

		.el-table td.el-table__cell,
		.el-table th.el-table__cell.is-leaf {
			border-bottom: 1px solid #2E8DB4 !important;
		}

		.el-table--border::after,
		.el-table--group::after,
		.el-table::before {
			background-color: #1f3b72 !important;
		}

		.el-table--border .el-table__cell,
		.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
			border-right: 1px solid #2E8DB4 !important;
		}

		.el-table thead {
			color: #A8CCDE !important;
		}

		.el-table {
			color: #A8CCDE !important;
			font-size: 16px !important;
		}

		.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
			background-color: transparent !important;
		}

		.el-table__body-wrapper {
			&::-webkit-scrollbar {
				width: 0px;
				background: rgba(213, 215, 220, 0.3);
				border: none;
			}

			&::-webkit-scrollbar-track {
				border: none;
			}
		}

		th.gutter {
			display: none !important;
			width: 0 !important
		}

		colgroup col[name='gutter'] {
			display: none;
			width: 0;
		}

		.el-table__body {
			width: 100% !important;
		}

		.title-img {
			width: 100%;
			height: 70px;
			background-image: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704181612497.png");
			background-size: 100% 100%;
		}

		.title {
			padding-left: 30px;
			position: relative;
			top: -8px;
		}

		.state-bg {
			width: 100%;
			height: 270px;
			background-image: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704181399133.png");
			background-size: 100% 100%;
			margin-bottom: 20px;

			.roll {
				overflow-y: auto;
				display: flex;
				flex-wrap: wrap;
				height: 426px;
				position: absolute;
				top: 30px;
				left: 20px;
				width: 92%;

				&::-webkit-scrollbar {
					width: 0 !important
				}
			}


		}

		.el-checkbox,
		.el-checkbox-button__inner {
			color: #FFFFFF;
		}

		.el-checkbox__inner {
			background-color: transparent;
		}

		.el-checkbox__input.is-checked .el-checkbox__inner,
		.el-checkbox__input.is-indeterminate .el-checkbox__inner {
			border-color: #00FFE7;
			background-color: #00FFE7;
		}

		.el-checkbox__input.is-checked .el-checkbox__inner::after {
			color: #A8CCDE !important;
		}

		.el-checkbox__inner::after {
			border: 2px solid #020936;
			border-left: 0;
			border-top: 0;
		}
	}
</style>